export const STATUS_CODE = {
    STORAGE_COMPLETE: '6',
    DELIVERY_UPLOAD_COMPLETE: '10',
    DELIVERY_STORAGE_COMPLETE: '12',
};

export const NO_SEND_FLG = {
    SEND: '0',
    NO_SEND: '1'
};

export const PROMPTLY_FLG = {
    PUBLISH_SELECT_DATE: '0',
    PUBLISH_IMMEDIATELY: '1'
};

export const USERROLE_CODE = {
    SERVICE_MANAGER_CODE: '001',
};

export const API_URL = {
    LOGIN: 'login',
    LOGIN_INDEX: 'login/index',
    TOKEN: 'login/token',
    USERID: 'login/userid',
    FUNCROLE: 'funcrole',
    NOTICE: 'notice',
    SELECT_ITEM_ORGLEVEL0: 'selectitem/orglevel0',
    SELECT_ITEM_AUDIT: 'selectitem/audit',
    SELECT_ITEM_PROJ: 'selectitem/proj',
    SELECT_ITEM_USERLIST: 'selectitem/userlist',
    UPHIST_CLIENT: 'uphist/client',
    UPHIST_IQVIA: 'uphist/iqvia',
    USER_ITEM: 'userlist',
    CSV_FILE: 'CSVFile',
    DOWNLOAD: 'download',
    PROJECT: 'project',
    UPLOAD_CLIENT: 'upload/client',
    UPLOAD_IQVIA_UPLOAD: 'upload/iqvia/upload',
    UPLOAD_IQVIA_REPLACE: 'upload/iqvia/replace',
    UPFILE: 'upfile',
    USER_MANAGEMENT: 'usermanagement/userlist',
    SELECT_ITEM_ORGLIST: 'selectitem/orglist',
    SELECT_ITEM_USER_ROLE_LIST: 'selectitem/usrrolelist',
    USER_UPSERT: 'usermanagement/upsert',
    FOLDER_LIST: 'foldermanagement/folderlist',
    AUDIT_ORG_PROJ_LIST: 'selectitem/auditorgprojlist',
    PROJ_LIST: 'selectitem/projList',
    USER_ROLE_LIST_PROJ: 'foldermanagement/usrusrrolelistproj',
    USER_ROLE_LIST: 'foldermanagement/usrusrrolelist',
    FOLDER_CREATE: "foldermanagement/foldercreate",
    FOLDER_UPDATE: "foldermanagement/foldernamechange",
    FOLDER_DELETE: "foldermanagement/folderdelete",
    FOLDER_AUTH: "foldermanagement/folderauth",
    FOLDER_MANAGEMENT_LINK: "foldermanagement/foldermanagelink",
    SELECT_ITEM_GET_IQVIACODE: 'selectitem/getIqviaOrgcode',
    FOLDER_CHECK: "selectitem/folderlist",
    AUDIT_AUTH: "auditauth/upsert",
    AUDIT_AUTH_USER_ROLE_LIST_AUDIT: "auditauth/auditusrrolelistaudit",
    AUDIT_AUTH_USER_ROLE_LIST: "auditauth/auditusrrolelist",
    AUDIT_AUTH_AUDIT: 'auditauth/audit',
    SHARE_ACCESS_USER_LIST: 'shareaccess/userlist',
    SHARE_ACCESS_UPSERT: 'shareaccess/upsert',
    UPLOADSCHEDULE_SCHEDULELIST: 'uploadschedule/schedulelist',
    UPLOADSCHEDULE_UPSERT: 'uploadschedule/upsertschedule',
    UPLOADSCHEDULE_DELETE: 'uploadschedule/deleteschedule',
    UPLOADSCHEDULE_RESULT: 'uploadschedule/scheduleresult',
    UPLOADSCHEDULE_SHAREFILELIST: 'uploadschedule/sharefilelist',
    UPLOADSCHEDULE_CSV_DOWNLOAD: 'uploadschedule/csv-download',
    CHATBOT_GETAUDITCAT: 'chatbot/getauditcategory',
    CHATBOT_GETHIST: 'chatbot/getHist',
    CHATBOT_QUESTION: 'chatbot/question',
    CHATBOT_ANSWEREVALUATEION: 'chatbot/answerevaluation',
    CHATBOT_SESSIONEVALUATEION: 'chatbot/sessionevaluation',
    FOLDER_PERMISSIONS: '/usermanagement/folderpermissions', //フォルダ権限取得
    USER_DELETE: '/usermanagement/deleteuser', // ユーザ削除
    RESEND_INVITE: 'usermanagement/resendinvite',  // 招待メール再送
    RESEND_INVITE_TARGET_CHECK: 'usermanagement/resendinvitetargetcheck', // 招待メール再送対象チェック
    GET_BLOCKED_EXTENSIONS: 'upload/blockedextensions', // ブロック拡張子取得
};

export const SYS_ROLE = {
    APP_BAR: 'AppBar',
    PORTAL: 'Portal',
    FILE_MANAGEMENT: 'FileManagement',
    FOLDER_MANAGEMENT: 'FolderManagement',
    DELIVERY_FILE_MANAGEMENT: 'DeliveryFileManagement',
    UPLOAD_PAGE: 'UploadPage',
    UPLOAD_DELIVERY: 'UploadDelivery',
    UPLOAD_UPDATE: 'UploadUpdate',
    USER_MANAGEMENT: 'UserManagement',
    ADD_USER: 'AddUser',
    UPDATE_USER:'UpdateUser',
    CREATE_FOLDER: 'CreateFolder',
    SETTING_PERMISSION: 'SettingPermission',
    USER_SEARCH: 'UserSearch',
    MANAGE_SERVICE: 'ManageService',
    UPLOAD_SCHEDULE: 'UploadSchedule',
    CHATBOT: 'Chatbot',
};

export const OBJ_ROLE = {
    HOME_LINK: 'homeLink',
    FILE_MANAGEMENT_LINK: 'fileManagementLink',
    USER_MANAGEMENT_LINK: 'userManagementLink',
    FOLDER_MANAGEMENT_LINK: 'folderManagementLink',
    DELIVERY_FILE_MANAGEMENT_LINK: 'deliveryFileManagementLink',
    CHANGE_LANGUAGE: 'changeLanguage',
    ORG_SELECTOR: 'orgSelector',
    SERVICE_SELECTOR: 'serviceSelector',
    PROJ_SELECTOR: 'projSelector',
    DELIVERY_DATE_RANGE: 'deliveryDateRange',
    DOWNLOAD_LIST_BTN: 'downloadListBtn',
    UPLOAD_FILE_SELECTOR: 'uploadFileSelector',
    NOTICES: 'notices',
    UPLOAD_FILE_BTN: 'uploadFileBtn',
    INFORMATION: 'information',
    OPEN_DATE_CHK: 'openDateChk',
    MAIL_SEND_CHK: 'mailSendChk',
    DOWNLOAD_FILE_LINK: 'downloadFileLink',
    ADD_USER_BTN: 'addUserBtn',
    SAVE_BTN: 'saveBtn',
    USER_UPDATE_LINK:'userUpdateLink',
    USER_ID:'userid',
    USER_NAME_JP:'usernamejp',
    USER_NAME_EN:'usernameen',
    ORG1_SELECTOR:'org1Selector',
    MAIL_ADDRESS:'mailaddress',
    EXPIRY_DATE:'expirydate',
    SERVICE_CODE:'servicecode',
    SERVICE_CREATE_BTN: 'serviceCreateBtn',
    SERVICE_DELETE_BTN: 'serviceDeleteBtn',
    ORG_CODE:'orgcode',
    ORG_CREATE_BTN: 'orgCreateBtn',
    ORG_DELETE_BTN: 'orgDeleteBtn',
    PROJ_CREATE_BTN: 'projCreateBtn',
    PROJ_DELETE_BTN: 'projDeleteBtn',
    PERMISSION_SELECTOR: 'permissionSelector',
    CREATE_FOLDER_BTN: 'createFolderBtn',
    SETTING_PERMISSION_BTN: 'settingPermissionBtn',
    SETTING_PERMISSION_LINK: 'settingPermissionLink',
    SEARCH_USER_BTN: 'searchUserBtn',
    USER_DELETE: 'userDelete',
    USER_CANCEL_BTN: 'userCancelBtn',
    ADD_USERMANUAL_BTN: 'manualUserAddBtn',
    ADD_USERAUTO_BTN: 'autoUserAddBtn',
    USER_DELETE_BTN: 'userDeleteBtn',
    FILE_PERIOD_CHK: 'filePeriodChk', // 追加: ファイル保管期間チェックボックス
};